import { Field } from 'redux-form';
import React from 'react';
import { hospitalListFetch, hospitalListUnload } from '../../lib/redux/actions/hospitals';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TypeAheadField from '../common/reduxForm/TypeaheadField';

const mapStateToProps = (state) => ({
  ...state.hospitals,
});
const mapDispatchToProps = {
  hospitalListFetch,
  hospitalListUnload,
};

class HospitalTypeahead extends React.Component {
  onSearch(query) {
    const { defaultFilters = {} } = this.props;
    const filters = { name: query, ...defaultFilters, pagination: false };
    this.props.hospitalListFetch(1, filters);
  }

  componentDidUpdate() {
    const { shouldClear, hasCleared } = this.props;
    if (shouldClear) {
      this.hospitalRef.getRenderedComponent().clear();
      hasCleared();
    }
  }

  componentWillUnmount() {
    this.props.hospitalListUnload();
  }

  render() {
    const {
      onChange,
      hospitals = [],
      label = 'Hospitals',
      name = 'hospitals',
      multiple = true,
      isFetchingHospitals,
      selectedHospitals = [],
      error,
      disabled = false,
    } = this.props;

    let optHospitals = [];
    // Filter out already selected hospitals from search results
    if (hospitals.length > 0 && selectedHospitals.length > 0) {
      // ensure selected options don't already exist in the dropdown.
      optHospitals = hospitals.filter((x) => !selectedHospitals.filter((y) => y.id === x.id).length);
    } else if (hospitals.length > 0) {
      // if none selected so far then allow all returned as options
      optHospitals = hospitals;
    }
    return (
      <>
        <Field
          name={name}
          isLoading={isFetchingHospitals}
          label={label}
          onSearch={this.onSearch.bind(this)}
          options={optHospitals}
          labelKey="name"
          selected={selectedHospitals}
          component={TypeAheadField}
          multiple={multiple}
          onChange={(selected) => {
            this.props.hospitalListUnload();
            onChange(selected);
          }}
          ref={(ref) => (this.hospitalRef = ref)}
          forwardRef
          disabled={disabled}
        />

        {error && <small className="form-text text-danger">{error}</small>}
      </>
    );
  }
}

HospitalTypeahead.propTypes = {
  shouldClear: PropTypes.bool.isRequired,
  hasCleared: PropTypes.func.isRequired,
  isFetchingHospitals: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  hospitalListFetch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(HospitalTypeahead);
